import { render } from "./Versions.vue?vue&type=template&id=1a6b1854"
import script from "./Versions.vue?vue&type=script&setup=true&lang=js"
export * from "./Versions.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Planning/Versions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a6b1854"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a6b1854', __exports__)) {
    api.reload('1a6b1854', __exports__)
  }
  
  module.hot.accept("./Versions.vue?vue&type=template&id=1a6b1854", () => {
    api.rerender('1a6b1854', render)
  })

}


export default __exports__